import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import HomePage from "./pages/HomePage";

// Code-split the non-landing routes so the initial bundle doesn't carry every page
// (including the heavy dashboard embeds). HomePage stays eager for instant first paint.
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ResumePage = lazy(() => import("./pages/ResumePage"));
const ProjectsAndResearch = lazy(() => import("./pages/ProjectsAndResearch"));
const DashboardFrameworkPage = lazy(() => import("./pages/DashboardFrameworkPage"));
const LinklePage = lazy(() => import("./pages/LinklePage"));
const SalesInventoryDashboard = lazy(() => import("./pages/dashboards/SalesInventoryDashboard"));
const FlightPulseMap = lazy(() => import("./pages/dashboards/FlightPulseMap"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

export default function App() {
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/projects" element={<ProjectsAndResearch />} />
        <Route path="/projects/dashboard-framework" element={<DashboardFrameworkPage />} />
        <Route path="/projects/linkle" element={<LinklePage />} />
        <Route path="/dashboards/sales-inventory" element={<SalesInventoryDashboard />} />
        <Route path="/dashboards/flight-pulse" element={<FlightPulseMap />} />

        {/* 404 Not Found page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
